import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

const SearchTabs = () => {
  const router = useRouter();

  const isActiveRoute = (path) => {
    switch (path) {
      case 'explore':
        if (
          router.pathname === '/explore'
          || router.pathname === '/search'
          || router.pathname === '/search/[[...query]]'
        ) {
          return true;
        }
        break;

      case 'hashtag':
        if (
          router.pathname === '/hashtag'
          || router.pathname === '/hashtag/[[...query]]'
        ) {
          return true;
        }
        break;

      case 'find-msers':
        if (router.pathname === '/find-msers') {
          return true;
        }
        break;

      default:
        return false;
    }
    return false;
  };

  return (
    <div className="tabs search-tabs is-toggle">
      <ul>
        <li className={isActiveRoute('explore') ? 'is-active' : ''}>
          <Link href="/explore" as="/explore">
            Picked for you
          </Link>
        </li>
        <li className={isActiveRoute('hashtag') ? 'is-active' : ''}>
          <Link href="/hashtag/[[...query]]" as="/hashtag">
            Browse topics
          </Link>
        </li>
        <li className={isActiveRoute('find-msers') ? 'is-active' : ''}>
          <Link href="/find-msers" as="/find-msers">
            Find MSers
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default SearchTabs;
